/* eslint-disable camelcase */

import {
  mdiSpeedometer,
  mdiRocket,
  mdiAxisArrow,
  mdiMapMarkerDistance,
  mdiAlarm,
} from '@mdi/js'

import { durationLocalized, travelTimeLocalized, valueFormatted } from '@/utils/travels'
import { DangerousState } from '@/enum'
import { dangerousStateIcons } from '@/utils/icons'

const icons = dangerousStateIcons()

export class Route {
  /* TODO: create model for point? */
  constructor ({
    path = {
      type: 'LineString',
      coordinates: []
    }, average_speed = 0.0, max_speed = 0.0, max_acceleration = 0.0, distance = 0.0, duration = 0,
    distraction_no_attention = 0, distraction_no_face = 0,
    drowsiness_count = 0, nobelt_count = 0, camera_sabotage = 0, cellphone_use = 0,
    eating_count = 0, smoking_count = 0,
    is_report = true
  } = {}) {
    this.path = Object.freeze(path) // we don't need any listeners on large arrays
    this.averageSpeed = average_speed
    this.maxSpeed = max_speed
    this.maxAcceleration = max_acceleration
    this.distance = distance
    this.duration = duration
    this.distractionNoAttention = distraction_no_attention
    this.distractionNoFace = distraction_no_face
    this.drowsinessCount = drowsiness_count
    this.nobeltCount = nobelt_count
    this.cameraSabotage = camera_sabotage
    this.cellphoneUse = cellphone_use
    this.eatingCount = eating_count
    this.smokingCount = smoking_count
    this.isReport = is_report
  }

  get pathStart () {
    if (this.path.coordinates.length > 0) {
      const point = this.path.coordinates[0]
      return { lat: point[1], lng: point[0] }
    } else {
      return { lat: 0.0, lng: 0.0 }
    }
  }

  get pathFinish () {
    if (this.path.coordinates.length > 0) {
      const point = this.path.coordinates[this.path.coordinates.length - 1]
      return { lat: point[1], lng: point[0] }
    } else {
      return { lat: 0.0, lng: 0.0 }
    }
  }

  get durationLocalized () {
    return durationLocalized(this.duration)
  }

  get formattedTime () {
    return travelTimeLocalized(this.datetimestart)
  }

  routeState () {
    return [
      {
        title: '$vuetify.map.travelStats.distance.title',
        value: valueFormatted(this.distance / 1000),
        icon: mdiMapMarkerDistance,
        postfix: '$vuetify.map.travelStats.distance.postfix',
        color: 'black',
      },
      {
        title: '$vuetify.map.travelStats.averageSpeed.title',
        value: valueFormatted(this.averageSpeed),
        icon: mdiSpeedometer,
        postfix: '$vuetify.map.travelStats.averageSpeed.postfix',
        color: 'black',
      },
      {
        title: '$vuetify.map.travelStats.duration.title',
        value: this.durationLocalized,
        icon: mdiAlarm,
        color: 'black',
      },
      {
        title: '$vuetify.map.travelStats.maxSpeed.title',
        value: valueFormatted(this.maxSpeed),
        icon: mdiRocket,
        postfix: '$vuetify.map.travelStats.maxSpeed.postfix',
        color: 'black',
      },
      {
        title: '$vuetify.map.travelStats.maxAcceleration.title',
        value: valueFormatted(this.maxAcceleration),
        icon: mdiAxisArrow,
        postfix: '$vuetify.map.travelStats.maxAcceleration.postfix',
        color: 'black',
      },
      // {
      //   title: '$vuetify.map.travelStats.distractionCount.title',
      //   value: this.distractionCount,
      //   icon: icons[DangerousState.DISTRACTION],
      //   color: 'red',
      //   style: true,
      //   additionalStatisticsField: 'distractionDuration',
      //   backend: DangerousState.DISTRACTION
      // },
      {
        title: '$vuetify.map.travelStats.distractionNoAttentionCount.title',
        value: this.distractionNoAttention,
        icon: icons[DangerousState.DISTRACTION_NO_ATTENTION],
        color: 'red',
        style: true,
        additionalStatisticsField: 'distractionNoAttentionDuration',
        backend: DangerousState.DISTRACTION_NO_ATTENTION
      },
      {
        title: '$vuetify.map.travelStats.distractionNoFaceCount.title',
        value: this.distractionNoFace,
        icon: icons[DangerousState.DISTRACTION_NO_FACE],
        color: 'brown',
        style: true,
        additionalStatisticsField: 'distractionNoFaceDuration',
        backend: DangerousState.DISTRACTION_NO_FACE
      },
      {
        title: '$vuetify.map.travelStats.drowsinessCount.title',
        value: this.drowsinessCount,
        icon: icons[DangerousState.DROWSINESS],
        color: 'purple',
        style: true,
        additionalStatisticsField: 'closedEyesDuration',
        backend: DangerousState.DROWSINESS
      },
      {
        title: '$vuetify.map.travelStats.yawningCount.title',
        value: 0,
        icon: icons[DangerousState.YAWNING],
        color: 'pink',
        style: true,
        additionalStatisticsField: 'yawningDuration',
        backend: DangerousState.YAWNING,
        nonFilter: true
      },
      {
        title: '$vuetify.map.travelStats.nobeltCount.title',
        value: this.nobeltCount,
        icon: icons[DangerousState.BELT_NOT_FASTEN],
        color: 'black',
        style: true,
        additionalStatisticsField: 'beltUnfastenDuration',
        backend: DangerousState.BELT_NOT_FASTEN
      },
      {
        title: '$vuetify.map.travelStats.cameraSabotage.title',
        value: this.cameraSabotage,
        icon: icons[DangerousState.CAMERA_SABOTAGE],
        color: 'orange',
        style: true,
        additionalStatisticsField: 'cameraSabotageDuration',
        backend: DangerousState.CAMERA_SABOTAGE
      },
      {
        title: '$vuetify.map.travelStats.cellphoneUse.title',
        value: this.cellphoneUse,
        icon: icons[DangerousState.CELLPHONE_USE],
        color: 'green',
        style: true,
        additionalStatisticsField: 'phoneUsageDuration',
        backend: DangerousState.CELLPHONE_USE
      },
      {
        title: '$vuetify.map.travelStats.eatingCount.title',
        value: this.eatingCount,
        icon: icons[DangerousState.EATING],
        color: 'blue',
        style: true,
        additionalStatisticsField: 'eatingDuration',
        backend: DangerousState.EATING
      },
      {
        title: '$vuetify.map.travelStats.smokingCount.title',
        value: this.smokingCount,
        icon: icons[DangerousState.SMOKING],
        color: 'grey',
        style: true,
        additionalStatisticsField: 'smokingDuration',
        backend: DangerousState.SMOKING
      }
    ]
  }

  clearRoute () {
    return new Route()
  }
}
